import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { UI_MESSAGES } from 'src/app/app.contant';
import { PrBuyerHelperService } from 'src/app/modules/pr-buyer/services/pr-buyer-helper.service';
import { RfqService } from 'src/app/modules/pr-buyer/services/rfq/rfq.service';
import { SupplierService } from 'src/app/modules/supplier/services/supplier.service';

interface FileSize {
  file: File,
  formatSize: string
}
@Component({
  selector: 'app-supplier-rfq-Upload',
  templateUrl: './supplier-rfq-Upload.component.html',
  styleUrls: ['./supplier-rfq-Upload.component.scss']
})
export class SupplierRfqUploadComponent implements OnInit {

  public prFiles: Array<any> = [];
  public upload_remarks: any;
  public onClose!: Subject<boolean>;
  public rfqId!: any;

  constructor(public bsModalRef: BsModalRef,
    private _service: SupplierService,
    private _helperService: PrBuyerHelperService,
    private _toastrService: ToastrService) { }

  ngOnInit(): void {
    this.onClose = new Subject();
  }

  public onModalClose(): void {
    this.onClose.next(true);
    this.bsModalRef.hide();
  }

  public verifyFile(event: any): void {
    let file: File = [...event.target.files][0];
      this.prFiles.push({ file, formatSize: this._helperService.formatFileSize(file.size)});
  }

  public clearFile(): void {
    this.prFiles = [];
  }

  public UploadAttachment(): void {
    const formData = new FormData();
    this.prFiles.forEach((files:any)=>{
      formData.append("file", files.file);
    })
    this._service.uploadAttachmnet(this.rfqId, formData).subscribe((res: any) => {
      this._toastrService.success(res.message);
      this.onModalClose();
    }, err => {
      this._toastrService.error(err.error.message);
    });
  }

}
